import React from 'react';

import { isInternalLink } from '@sola/utils/url.ts';

export const parseInlineLinks = (text: string): React.ReactNode => {
  // eslint-disable-next-line sonarjs/slow-regex
  const linkPattern = /\[([^\]]+)\]\(([^)]+)\)/g;
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = linkPattern.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    const [, linkText, url] = match;
    parts.push(
      isInternalLink(url) ? (
        <a
          key={match.index}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {linkText}
        </a>
      ) : (
        linkText
      ),
    );

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  if (parts.length === 0) {
    return text;
  }

  return <>{parts}</>;
};
